// extracted by mini-css-extract-plugin
module.exports = {"postContainer":"postContainer--b+W9x","submitButton":"submitButton--CXxJ2"};